import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./main/routes/router";
import type {} from "@mui/x-data-grid/themeAugmentation";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: ["Ubuntu", " sans-serif"].join(","),
  },

  palette: {
    mode: "light",
    primary: {
      main: "#00158E",
    },
    secondary: {
      main: "#EF9506",
    },
    background: {
      default: "#F6F6F6",
      paper: "#FFF",
    },
    text: {
      primary: "#707070",
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
